;(function () {
  'use strict'

  angular
    .module('contrast.auth')
    .constant('LOGOUT_BASE_URL', '/Contrast/logout.html')
    .constant('LOGOUT_REDIRECT', {
      LOGOUT: '/static/ng/index.html#/pages/logout',
      SIGNIN: '/static/ng/index.html#/pages/signin'
    })
    .constant('SERVER_MESSAGES', {
      CSRF_ERROR: 'Invalid CSRF token'
    })

    .constant('SIGN_IN_URL', '/Contrast/static/ng/index.html#/pages/signin')
    .constant('ADMIN_PORTAL_RELATIVE_URL', 'superadmin/organizations')
    .constant(
      'ADMIN_PORTAL_URL',
      '/Contrast/static/ng/admin_index.html#/superadmin/organizations'
    )
    .constant('PORTAL_TYPES', {
      ORG: 'org',
      ADMIN: 'admin'
    })
    .constant('AUTH_EVENTS', {
      AUTHENTICATED_TRUE: 'user:authenticated:true',
      AUTHENTICATED_FALSE: 'user:authenticated:false',
      UNAUTHENTICATED_EVENT: 'user:unauthenticated'
    })
    .constant('LOGOUT_EVENTS', {
      TRIGGER_LOGOUT: 'logout:trigger'
    })
    .constant('TIMEOUT_EVENT', 'session:timeout')
    .constant('ORGANIZATION_SWITCH_EVENT', 'org:switch')
})()
